import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  getConnections,
  GettingAllModels,
  GettingAllTools,
} from "../../allApi/api";

export const fetchModels = createAsyncThunk("data/fetchModels", async () => {
  const response = await GettingAllModels();
  return response?.models;
});

export const fetchTools = createAsyncThunk("data/fetchTools", async () => {
  const response = await GettingAllTools();
  return response?.tools;
});

export const getActiveConnectionsTools = createAsyncThunk(
  "data/getActiveConnectionsTools",
  async () => {
    try {
      const res = await getConnections();
      let statusdata = res?.data?.connections
        .filter((ele) => ele.status == "ACTIVE")
        .map((ele) => ele.toolkit_slug);
      let activeConnectionList = [...new Set(statusdata)];
      return activeConnectionList;
    } catch (error) {
      console.error("error:", error);
    }
  }
);

const initialData = {
  toolFetched: false,
  modelFetched: false,
  activeConnectionFetched: false,
  modelList: [],
  toolsList: [],
  activeConnectionList: [],
  error: null,
  loading: false,
  preDefineTools: [],
};

const toolModelData = createSlice({
  name: "tooldModel",
  initialState: initialData,
  reducers: {
    clearModelFetch: (state) => {
      state.modelFetched = false;
    },
    cleareToolsFetch: (state) => {
      state.toolFetched = false;
    },
    cleareActiveConnectionFetch: (state) => {
      state.activeConnectionFetched = false;
    },
    setpreDefineTools: (state, { payload }) => {
      state.preDefineTools = Array.isArray(payload)
        ? payload
        : (payload && Array.isArray(payload.data) ? payload.data : []);
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchModels.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchModels.fulfilled, (state, action) => {
        state.modelList = action?.payload;
        state.modelFetched = true;
        state.loading = false;
      })
      .addCase(fetchModels.rejected, (state, action) => {
        state.error = action.error.message;
        state.loading = false;
      })
      .addCase(fetchTools.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchTools.fulfilled, (state, action) => {
        state.toolsList = action.payload;
        state.toolFetched = false;
        state.loading = false;
      })
      .addCase(fetchTools.rejected, (state, action) => {
        state.error = action.error.message;
        state.loading = false;
      })
      .addCase(getActiveConnectionsTools.pending, (state) => {
        state.loading = true;
      })
      .addCase(getActiveConnectionsTools.fulfilled, (state, action) => {
        state.activeConnectionList = action.payload;
        state.activeConnectionFetched = true;
        state.loading = false;
      })
      .addCase(getActiveConnectionsTools.rejected, (state, action) => {
        state.error = action.error.message;
        state.loading = false;
      });
  },
});

export const {
  cleareToolsFetch,
  clearModelFetch,
  cleareActiveConnectionFetch,
  setpreDefineTools
} = toolModelData.actions;

export default toolModelData.reducer;
